import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CsrPageComponent } from './components/csr-page/csr-page.component';
import { CsrListComponent } from './components/csr-list/csr-list.component';

const routes: Routes = [
  {
    path: '',
    component: CsrPageComponent,
    data: { title: '' },
    children: [
      {
        path: '',
        component: CsrListComponent,
        data: { title: '' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CsrProjectRoutingModule {}
